import AsosList from '../layout/pages/AsosList.vue'
import { createStore } from 'vuex'
import { markRaw } from 'vue'

export const dataAso = createStore({
  state: () => {
    return {
      docs: [], // list
      componentActive: AsosList,

      drawerModal: false,
      drawerModalContent: []
    }
  },
  getters: {
    getActiveComponent: (state) => state.componentActive,
    getDocs: (state) => state.docs,
    getDrawerModal: (state) => state.drawerModal,
    getDrawerModalContent: (state) => state.drawerModalContent
  },
  mutations: {
    SET_LIST_COMPONENT_ACTIVE (state) {
      state.componentActive = markRaw(AsosList)
    },
    SET_ALL_DOCS (state, value) {
      state.docs = []
      state.docs = value
    },
    SET_DRAWER_ACTIVE (state, payload) {
      state.drawerModalContent = []
      state.drawerModalContent = payload
      state.drawerModal = true
    },
    SET_DRAWER_DESACTIVE (state) {
      state.drawerModal = false
      state.drawerModalContent = []
    }
  },
  actions: {
    setAllDocs ({ commit }, val) {
      commit('SET_ALL_DOCS', val)
    },
    setListComponentActive ({ commit }) {
      commit('SET_LIST_COMPONENT_ACTIVE')
    },
    setModalActive ({ commit }, payload) {
      commit('SET_DRAWER_ACTIVE', payload)
    },
    setModalDesactive ({ commit }) {
      commit('SET_DRAWER_DESACTIVE')
    }
  }
})
